(() => {
  if (window.ttHeaderHoverReady) return;
  window.ttHeaderHoverReady = true;
  const controllers = new Map();
  const initialise = (root = document) => {
    root.querySelectorAll('[data-tt-hover-menu]').forEach(menu => {
      if (controllers.has(menu)) return;
      const details = menu.querySelector('details');
      const summary = details.querySelector('summary');
      const abort = new AbortController();
      const signal = abort.signal;
      const desktop = matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
      let timer;
      const close = () => { details.open = false; summary.setAttribute('aria-expanded', 'false'); };
      details.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(details.open)), { signal });
      menu.addEventListener('pointerenter', event => {
        if (!desktop.matches || event.pointerType === 'touch') return;
        clearTimeout(timer);
        document.querySelectorAll('[data-tt-hover-menu] details[open]').forEach(other => {
          if (other !== details && !other.contains(document.activeElement)) { other.open = false; other.querySelector('summary').setAttribute('aria-expanded', 'false'); }
        });
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      }, { signal });
      menu.addEventListener('pointerleave', event => {
        if (!desktop.matches || event.pointerType === 'touch') return;
        clearTimeout(timer);
        timer = setTimeout(() => { if (!menu.contains(document.activeElement)) close(); }, 160);
      }, { signal });
      menu.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !details.open) return;
        event.preventDefault();
        event.stopPropagation();
        close();
        summary.focus();
      }, { signal });
      desktop.addEventListener('change', () => { if (!desktop.matches) close(); }, { signal });
      controllers.set(menu, () => { clearTimeout(timer); abort.abort(); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [menu, cleanup] of controllers) if (event.target.contains(menu)) { cleanup(); controllers.delete(menu); }
  });
})();
